export default __webpack_public_path__ + "static/media/booking-step-one.dcf3af93.jpg";